export const theme = {
  accent: '#FF5A1F',
  bg: '#111114',
  card: '#1B1B20',
  border: '#24242A',
  borderLight: '#2E2E36',
  text: '#F5F5F2',
  textMuted: '#B7B7BE',
  textDim: '#6C6C75',
  green: '#00D084',
  fontDisplay: "'Archivo Black', sans-serif",
  fontHeading: "'Archivo', sans-serif",
  fontMono: "'Space Mono', monospace",
};
